import { render, staticRenderFns } from "./ThreeStyleEditor.vue?vue&type=template&id=8a5422cc&scoped=true&"
import script from "./ThreeStyleEditor.vue?vue&type=script&lang=js&"
export * from "./ThreeStyleEditor.vue?vue&type=script&lang=js&"
import style0 from "./ThreeStyleEditor.vue?vue&type=style&index=0&id=8a5422cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5422cc",
  null
  
)

export default component.exports